import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';

export interface UmpireComponentIframe
  extends UmpireComponent<UmpireComponentTypeEnum.IFRAME> {
  content: string;
}
